/* Skinko – mejoras de experiencia mobile.
   1) Barra fija de compra: visible siempre que el botón principal "Añadir al carrito" no esté en pantalla
      (y no se vea el pie de página). Al tocarla agrega directo al carrito con la misma animación y aviso.
      Si el producto está agotado mantiene el comportamiento del tema (lleva al botón).
   2) Botón de BON (Skinko Club) arrastrable en celular: se mueve con el dedo, al soltarlo se acomoda al borde
      más cercano, recuerda la posición y un toque corto lo sigue abriendo. */
(function () {
  if (window.__skUX) return;
  window.__skUX = true;
  var MOBILE = function () { return window.innerWidth < 900; };

  /* ---------- 1) Barra fija de compra ---------- */
  function initSticky() {
    var bar = document.querySelector('sticky-buy-button.wt-product__sticky-buy');
    var atc = document.querySelector('.wt-product__add-to-cart');
    if (!bar || !atc) return;
    var footer = document.querySelector('.wt-footer');
    var timer = null;

    function inView(el) {
      if (!el) return false;
      var r = el.getBoundingClientRect();
      return r.bottom > 0 && r.top < window.innerHeight;
    }
    function update() {
      timer = null;
      var on = !inView(atc) && !inView(footer);
      bar.classList.toggle('sk-sticky-on', on);
      document.body.classList.toggle('sk-sticky-buy-on', on && window.innerWidth < 1200);
    }
    function request() {
      if (!timer) timer = setTimeout(update, 60);
    }
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    update();
    setTimeout(update, 800);

    var stickyBtn = bar.querySelector('button');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function (e) {
        var form = document.querySelector('product-form form');
        var main = form && form.querySelector('[type="submit"]');
        if (!main || main.disabled || main.getAttribute('aria-disabled') === 'true') return;
        e.preventDefault();
        e.stopImmediatePropagation();
        main.click();
      }, true);
    }
  }

  /* ---------- 2) Botón BON arrastrable ---------- */
  var KEY = 'sk_bon_pos';
  var root = document.documentElement;
  var EDGE = 16, MIN_B = 20, WA_ZONE = 86;

  function readPos() {
    try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
  }
  function savePos(p) {
    try { localStorage.setItem(KEY, JSON.stringify(p)); } catch (e) {}
  }
  function clampBottom(b, side) {
    var max = window.innerHeight - 160;
    b = Math.max(MIN_B, Math.min(max, b));
    if (side === 'right' && b < WA_ZONE) b = WA_ZONE; /* no tapar WhatsApp */
    return Math.round(b);
  }
  function applyPos(p) {
    if (!p) return;
    root.setAttribute('data-sk-bon-side', p.side);
    root.style.setProperty('--sk-bon-left', p.side === 'right' ? 'auto' : EDGE + 'px');
    root.style.setProperty('--sk-bon-right', p.side === 'right' ? EDGE + 'px' : 'auto');
    root.style.setProperty('--sk-bon-bottom', clampBottom(p.bottom, p.side) + 'px');
  }
  /* Posición guardada aplicada lo antes posible, para que el botón aparezca directamente en su lugar */
  applyPos(readPos());

  function makeDraggable(btn) {
    if (btn.dataset.skDrag) return;
    btn.dataset.skDrag = '1';
    var start = null, moved = false, suppressClick = false;

    btn.addEventListener('pointerdown', function (e) {
      if (!MOBILE()) return;
      var r = btn.getBoundingClientRect();
      start = { x: e.clientX, y: e.clientY, left: r.left, bottom: window.innerHeight - r.bottom, w: r.width };
      moved = false;
      try { btn.setPointerCapture(e.pointerId); } catch (err) {}
    });
    btn.addEventListener('pointermove', function (e) {
      if (!start) return;
      var dx = e.clientX - start.x, dy = e.clientY - start.y;
      if (!moved && Math.abs(dx) + Math.abs(dy) < 8) return;
      moved = true;
      btn.classList.add('sk-dragging');
      var left = Math.max(4, Math.min(window.innerWidth - start.w - 4, start.left + dx));
      var bottom = Math.max(4, Math.min(window.innerHeight - start.w - 60, start.bottom - dy));
      root.style.setProperty('--sk-bon-left', left + 'px');
      root.style.setProperty('--sk-bon-right', 'auto');
      root.style.setProperty('--sk-bon-bottom', bottom + 'px');
      e.preventDefault();
    });
    function end() {
      if (!start) return;
      if (moved) {
        var r = btn.getBoundingClientRect();
        var side = (r.left + r.width / 2) > window.innerWidth / 2 ? 'right' : 'left';
        var p = { side: side, bottom: clampBottom(window.innerHeight - r.bottom, side) };
        btn.classList.remove('sk-dragging');
        btn.classList.add('sk-snap');
        applyPos(p);
        savePos(p);
        setTimeout(function () { btn.classList.remove('sk-snap'); }, 260);
        suppressClick = true;
        setTimeout(function () { suppressClick = false; }, 350);
      }
      start = null;
    }
    btn.addEventListener('pointerup', end);
    btn.addEventListener('pointercancel', end);
    btn.addEventListener('click', function (e) {
      if (suppressClick) { e.preventDefault(); e.stopImmediatePropagation(); }
    }, true);
  }

  function waitForBon() {
    var tries = 0;
    (function check() {
      var btn = document.getElementById('bon-loyalty-btn');
      if (btn) return makeDraggable(btn);
      if (++tries < 40) setTimeout(check, 500);
    })();
  }

  function init() {
    initSticky();
    waitForBon();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
